import $ from "jquery";
import config from "../../../config";
import {showError, showSuccess} from "../../layouts/actions";
import { getErrorMessage } from '../../utils';

// Action Types
export const NOT_LINKED_ITEMS_SET_LOADING = 'NOT_LINKED_ITEMS_SET_LOADING';
export const NOT_LINKED_DIRS_LOAD_DATA = 'NOT_LINKED_DIRS_LOAD_DATA';
export const NOT_LINKED_EMAILS_LOAD_DATA = 'NOT_LINKED_EMAILS_LOAD_DATA';
export const NOT_LINKED_DIR_LOAD_CHILDREN = 'NOT_LINKED_DIR_LOAD_CHILDREN';
export const NOT_LINKED_ITEMS_LOAD_DICTIONARIES = 'NOT_LINKED_ITEMS_LOAD_DICTIONARIES';
export const NOT_LINKED_EMAIL_CHILDREN_LOAD_DATA = 'NOT_LINKED_EMAIL_CHILDREN_LOAD_DATA';
export const NOT_LINKED_EMAILS_LOAD_EMAIL = 'NOT_LINKED_EMAILS_LOAD_EMAIL';

// Action Creators
const setLoading = (name, loading) => ({
  type: NOT_LINKED_ITEMS_SET_LOADING,
  name,
  loading,
});

export const getNotLinkedDirs = (params) => (dispatch) => {
  const loadingName = 'getNotLinkedDirs';
  dispatch(setLoading(loadingName, true));

  // Extract dateFrom and dateTo from params if they exist
  const queryParams = {};
  if (params && params.dateFrom) {
    queryParams.date_from = params.dateFrom.format('YYYY-MM-DD HH:mm:ss');
  }
  if (params && params.dateTo) {
    queryParams.date_to = params.dateTo.format('YYYY-MM-DD HH:mm:ss');
  }
  // Add pagination parameter if provided
  let loadNext = false;
  if (params && params.nextFilename) {
    queryParams.next_filename = params.nextFilename;
    loadNext = true;
  }
  if (params && params.clientServiceUser) {
    queryParams.cs_user = params.clientServiceUser;
  }
  if (params && params.seriesNameOrCode) {
    queryParams.series = params.seriesNameOrCode;
  }
  if (params && params.clientName) {
    queryParams.client_company = params.clientName.map(client => client.value);
  }
  if (params && params.woLinked) {
    queryParams.include_wo_linked = params.woLinked;
  }

  return $.ajax({
    method: "GET",
    url: `${config.apiUrl}/v1/file_system/not_linked_items/dirs`,
    data: queryParams,
  })
    .done((res) => {
      const responseData = res.not_linked_dirs || {};
      dispatch({
        type: NOT_LINKED_DIRS_LOAD_DATA,
        items: responseData.items || [],
        nextFilename: responseData.next_filename || null,
        loadNext: loadNext,
        associatedEmailsWithDirs: res.associated_emails_with_dirs || []
      });
    })
    .fail((error) => {
      dispatch(
        showError(
          `An error occurred while loading orphaned directories. ${getErrorMessage(error)}`
        )
      );
    })
    .always(() => {
      dispatch(setLoading(loadingName, false));
    });
};

// Legacy method for backward compatibility - calls both endpoints
export const getNotLinkedItems = (params) => (dispatch) => {
  return Promise.allSettled([
    dispatch(getNotLinkedDirs(params)),
    dispatch(getNotLinkedEmails(params))
  ]);
};

export const getNotLinkedEmails = (params) => (dispatch) => {
  const loadingName = 'loadMoreEmails';
  dispatch(setLoading(loadingName, true));

  // Extract dateFrom and dateTo from params if they exist
  const queryParams = {};
  if (params && params.dateFrom) {
    queryParams.date_from = params.dateFrom.format('YYYY-MM-DD HH:mm:ss');
  }
  if (params && params.dateTo) {
    queryParams.date_to = params.dateTo.format('YYYY-MM-DD HH:mm:ss');
  }
  // Add pagination parameter if provided
  let loadNext = false;
  if (params && params.nextMessageId) {
    queryParams.next_message_id = params.nextMessageId;
    loadNext = true;
  }
  if (params && params.clientServiceUser) {
    queryParams.cs_user = params.clientServiceUser;
  }
  if (params && params.seriesNameOrCode) {
    queryParams.series = params.seriesNameOrCode;
  }
  if (params && params.clientName) {
    queryParams.client_company = params.clientName.map(client => client.value);
  }
  if (params && params.woLinked) {
    queryParams.include_wo_linked = params.woLinked;
  }

  return $.ajax({
    method: "GET",
    url: `${config.apiUrl}/v1/file_system/not_linked_items/emails`,
    data: queryParams,
  })
    .done((res) => {
      const responseData = res.not_linked_emails || {};
      dispatch({
        type: NOT_LINKED_EMAILS_LOAD_DATA,
        items: responseData.items || [],
        nextMessageId: responseData.next_message_id || null,
        loadNext: loadNext,
      });
    })
    .fail((error) => {
      dispatch(
        showError(
          `An error occurred while loading more emails. ${getErrorMessage(error)}`
        )
      );
    })
    .always(() => {
      dispatch(setLoading(loadingName, false));
    });
};

export const getFolderItems = (params) => (dispatch) => {
  const loadingName = 'getFolderItems';
  dispatch(setLoading(loadingName, true));

  return $.ajax({
    method: 'GET',
    url: `${config.apiUrl}/v1/file_system/root/${params.fsRootID}/content/${params.contentID}`,
    data: {
      with_children: true,
    }
  })
  .done(res => {
    const responseData = res.data || {};
    dispatch({
      type: NOT_LINKED_DIR_LOAD_CHILDREN,
      children: responseData.children || [],
    });
  })
  .fail((error) => {
    dispatch(
      showError(
        `An error occurred while loading folder items. ${getErrorMessage(error)}`
      )
    );
  })
  .always(() => {
    dispatch(setLoading(loadingName, false));
  });
};

export const getNotLinkedItemsDictionaries = (params) => (dispatch) => {
  const loadingName = 'getNotLinkedItemsDictionaries';
  dispatch(setLoading(loadingName, true));

  const queryParams = {};
  if (params && params.dateFrom) {
    queryParams.date_from = params.dateFrom.format('YYYY-MM-DD HH:mm:ss');
  }
  if (params && params.dateTo) {
    queryParams.date_to = params.dateTo.format('YYYY-MM-DD HH:mm:ss');
  }

  return $.ajax({
    method: 'GET',
    url: `${config.apiUrl}/v1/file_system/not_linked_items/dictionary`,
    data: queryParams,
  })
  .done(res => {
    dispatch({
      type: NOT_LINKED_ITEMS_LOAD_DICTIONARIES,
      csUserList: res.cs_user_list || [],
      clientList: res.client_list || [],
      tagsFilterList: res.tags_filter_list || [],
      csUserLeaderboard: res.cs_user_leaderboard || [],
    });
  })
  .fail((error) => {
    dispatch(
      showError(
        `An error occurred while loading dictionaries. ${getErrorMessage(error)}`
      )
    );
  })
  .always(() => {
    dispatch(setLoading(loadingName, false));
  });
};

export const selectAssigneeForEmail = (msgId, assignee) => (dispatch, getState) => {
  dispatch(setLoading('selectAssigneeForEmail', true));
  const loggedUserEmail = getState().user.email || '';

  return $.ajax({
    type: 'POST',
    url: `${config.apiUrl}/v1/file_system/fd_messages/tags/assignee`,
    data: {
      email: loggedUserEmail,
      msg_id: msgId,
      assignee: assignee
    }
  }).done(res => {
    dispatch(reloadFdMessage(msgId));
    dispatch(showSuccess("Email assignee was successfully changed"));
  }).fail(error => {
    dispatch(
      showError(
        `An error occurred while selecting assignee for email. ${getErrorMessage(error)}`
      )
    );
  }).always(() => {
    dispatch(setLoading('selectAssigneeForEmail', false));
  });
};

export const loadWorkOrderList = (searchParams) => (dispatch) => {
  const isWoNumCategory = t => /^WO[0-9]+$/i.test(t);
  const woMemfisField = ['show_name', 'show_code', 'ep_num'].find(k => isWoNumCategory(searchParams[k]));

  return $.ajax({
    method: 'GET',
    url: `${config.apiUrl}/v1/file_system/all_memfis_wo`,
    data: {
      filters: JSON.stringify({
        qod_only: false,
        ...(woMemfisField ? {search: searchParams[woMemfisField]} : searchParams)
      })
    }
  });
};

const makeModifyEmailTagRequest = (msgId, tag, action) => (dispatch, getState) => {
  dispatch(setLoading('modifyEmailTag', true));
  const loggedUserEmail = getState().user.email || '';

  return $.ajax({
    type: 'POST',
    url: `${config.apiUrl}/v1/file_system/fd_messages/tags/${action}`,
    data: {
      email: loggedUserEmail,
      msg_id: msgId,
      msg_tag: tag
    }
  }).done(res => {
    dispatch(reloadFdMessage(msgId));
    dispatch(showSuccess("Email tag was successfully changed"));
  }).fail(error => {
    dispatch(
      showError(
        `An error occurred while modifying email tag. ${getErrorMessage(error)}`
      )
    );
  }).always(() => {
    dispatch(setLoading('modifyEmailTag', false));
  });
};

export const addTagForEmail = (msgId, tag) => makeModifyEmailTagRequest(msgId, tag, 'add');

export const removeTagForEmail = (msgId, tag) => makeModifyEmailTagRequest(msgId, tag, 'remove');

export const reloadFdMessage = (messageId) => (dispatch, getState) => {
  const currentNextMessageId = getState().notLinkedItems.nextMessageId || null;
  const currentEmailsList = getState().notLinkedItems.notLinkedEmails || [];

  return $.ajax({
    method: "GET",
    url: `${config.apiUrl}/v1/file_system/not_linked_items/emails`,
    data: {
      message_id: messageId,
    },
  }).done(res => {
    const fdMessage = res.email || {};
    const newEmailsList = currentEmailsList.map(email => {
      if (email.message_id === messageId) {
        return {
          ...email,
          asset_url: fdMessage.asset_url,
          root_id: fdMessage.root_id,
          content_id: fdMessage.content_id,
          msg_tags: fdMessage.msg_tags,
        };
      }
      return email;
    });
    dispatch({
      type: NOT_LINKED_EMAILS_LOAD_DATA,
      items: newEmailsList,
      nextMessageId: currentNextMessageId,
    });
  });
};

export const linkEmailToFolder = (messageId, rootId, contentId) => editEmailRootAndContent(messageId, rootId, contentId);

export const unlinkEmailFromFolder = (messageId) => editEmailRootAndContent(messageId, null, null);

const editEmailRootAndContent = (messageId, rootId, contentId) => (dispatch, getState) => {
  const loadingName = 'editEmailRootAndContent';
  dispatch(setLoading(loadingName, true));

  const resetRootAndContentMode = rootId === null && contentId === null;
  return $.ajax({
    method: 'POST',
    url: `${config.apiUrl}/v1/file_system/not_linked_items/asset_url`,
    data: {
      message_id: messageId,
      root_id: rootId,
      content_id: contentId
    }
  })
  .done((res) => {
    dispatch(reloadFdMessage(messageId));
    if (resetRootAndContentMode) {
      dispatch(showSuccess('Email has been successfully unlinked from the folder'));

      const currentNotLinkedDirs = getState().notLinkedItems.notLinkedDirs || [];
      const currentNextFilename = getState().notLinkedItems.nextFilename || null;
      const newAssociatedEmailsWithDirs = (getState().notLinkedItems.associatedEmailsWithDirs || [])
        .filter(email => email.message_id !== messageId);

      dispatch({
        type: NOT_LINKED_DIRS_LOAD_DATA,
        items: currentNotLinkedDirs,
        nextFilename: currentNextFilename,
        associatedEmailsWithDirs: newAssociatedEmailsWithDirs
      });
    } else {
      dispatch(showSuccess('Email has been successfully linked to the folder'));
    }
  })
  .fail((error) => {
    dispatch(
      showError(
        `An error occurred while linking email to folder. ${getErrorMessage(error)}`
      )
    );
  })
  .always(() => {
    dispatch(setLoading(loadingName, false));
  });
};

export const loadEmailChildren = (messageId) => (dispatch) => {
  const loadingName = 'loadEmailChildren';
  dispatch(setLoading(loadingName, true));

  return $.ajax({
    method: 'GET',
    url: `${config.apiUrl}/v1/file_system/not_linked_items/email_references`,
    data: {
      message_id: messageId
    }
  })
  .done((res) => {
    const children = res.children || [];
    dispatch({
      type: NOT_LINKED_EMAIL_CHILDREN_LOAD_DATA,
      messageId: messageId,
      children: children,
    });
  })
  .fail((error) => {
    dispatch(
      showError(
        `An error occurred while loading email children. ${getErrorMessage(error)}`
      )
    );
  })
  .always(() => {
    dispatch(setLoading(loadingName, false));
  });
};

export const getEmailData = (msgId) => (dispatch) => {
  const loadingName = 'getEmailData';
  dispatch(setLoading(loadingName, true));
  dispatch({
    type: NOT_LINKED_EMAILS_LOAD_EMAIL,
    emailData: null,
  });

  return $.ajax({
    method: 'GET',
    url: `${config.apiUrl}/v1/file_system/fd_messages`,
    data: {
      msg_id: msgId
    }
  })
  .done((res) => {
    dispatch({
      type: NOT_LINKED_EMAILS_LOAD_EMAIL,
      emailData: res,
    });
  })
  .fail((error) => {
    dispatch(
      showError(
        `An error occurred while loading email data. ${getErrorMessage(error)}`
      )
    );
  })
  .always(() => {
    dispatch(setLoading(loadingName, false));
  });
};
